// extracted by mini-css-extract-plugin
export default {"main":"contact_main__knUFK"};